import { PortfolioContainer } from '@/components/DeprecatedPortfolio';
export default PortfolioContainer;
